import React, { PropTypes } from 'react';
import Modal from 'components/UI/Modal'
import { confirmable } from 'react-confirm';
import classnames from 'classnames'
import './confirm.scss';

class Confirmation extends React.Component {
  render() {
    const {
      okButtonTitle,
      cancelButtonTitle,
      title,
      confirmation,
      show,
      proceed,
      dismiss,
      cancel,
      enableEscape = true,
		} = this.props;

    return (
			<Modal
				isShowingModal={show} // if you want to show it when component mounts, set it true
				className={classnames("confirm-modal")}
				fixedWidth={400}
				allowCloseByClickingShadow={true}
				useDefaultCloseButton={false}

				// contentHeight={300}

				hasHeader={true}
				headerType="bold" // default, bold
				headerTitle={title}

				hasFooter={true}
				footerType="bold" // grey, transparent, bold
				footerButtons={[
					{
						title: okButtonTitle || __("Confirm", "UI.confirm"), 
						className: "btn btn-primary pull-right",
						onClick: proceed
					},
					{
						title: cancelButtonTitle || __("Cancel", "UI.confirm"), 
						className: "btn btn-default pull-right",
						onClick: cancel
					},
				]}
			>
				<div className='alert-content'>
					<div className='alert-text'>
						{confirmation}
					</div>
				</div>
			</Modal>
    )
  }
}

Confirmation.propTypes = {
  okButtonTitle: PropTypes.string,
  cancelButtonTitle: PropTypes.string,
  title: PropTypes.string,
  confirmation: PropTypes.string,
  show: PropTypes.bool,
  proceed: PropTypes.func,     // called when ok button is clicked.
  cancel: PropTypes.func,      // called when cancel button is clicked.
  dismiss: PropTypes.func,     // called when backdrop is clicked or escaped.
  enableEscape: PropTypes.bool,
}

export default confirmable(Confirmation);



// WEBPACK FOOTER //
// ./src/components/UI/Confirm/index.js